import { Controller } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import { DatePickerRangeControl, FormWrapperLabel, useTranslation } from '@ukpostbox/frontend-framework';
import { useSite } from '../../../../_Global/Providers/SiteInterfaceProvider';
import { SearchTypesType } from '../SearchControlTypes';

function SearchMailDateRange(props: SearchTypesType) {
	const { t } = useTranslation();
	const { currentLocale } = useSite();

	return (
		<Controller
			name='dateRange'
			control={props.formMethods.control}
			render={({ field, fieldState }) => (
				<FormWrapperLabel
					label={t('mailboxes.filter.labels.dateRange')}
					invalid={fieldState.invalid}
					validationMessage={fieldState.error?.message}
				>
					<DatePickerRangeControl
						name='dateRange'
						defaultDateRange={{
							from: props.searchParams?.get('startDate')
								? new Date(props.searchParams.get('startDate') as string)
								: undefined,
							to: props.searchParams?.get('endDate')
								? new Date(props.searchParams.get('endDate') as string)
								: undefined,
						}}
						forwardValueCallback={(e) => {
							props.formMethods.setValue(
								'startDate',
								e?.from
									? e.from
											.toLocaleString(currentLocale.code)
											.split(',')[0]
											.split('/')
											.reverse()
											.toString()
											.replace(/,/g, '-')
									: undefined,
							);
							props.formMethods.setValue(
								'endDate',
								e?.to
									? e.to
											.toLocaleString(currentLocale.code)
											.split(',')[0]
											.split('/')
											.reverse()
											.toString()
											.replace(/,/g, '-')
									: undefined,
							);
						}}
					/>
				</FormWrapperLabel>
			)}
		/>
	);
}

export { SearchMailDateRange };
